import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const GuideContentMobile = styled(Typography)(() => ({
  fontSize: '18px',
  fontWeight: 400,
  color: 'black',
  textAlign: 'center',
}));
